import { render, staticRenderFns } from "./FormAtestado.vue?vue&type=template&id=a57ce1e6&"
import script from "./FormAtestado.vue?vue&type=script&lang=js&"
export * from "./FormAtestado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports